<template>
  <div>
    <div class="">
      <div class="tableContainer">
        <div class="sampleTemplate" v-if="isAdmin">
          <b-table
            id="table1"
            ref="table1"
            :fields="fields"
            :items="getBoard"
            :per-page.sync="perPage"
            :current-page.sync="currentPage"
            @row-selected="onRowSelected"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            select-mode="multi"
            selectable
            show-empty
            empty-text="공지사항이 존재하지 않습니다."
          >
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>
            <template #cell(TITLE)="data">
              <span
                v-html="data.value"
                @click="showDetail(data.item.IDX)"
              ></span>
            </template>
            <template #cell(FILE_NAME)="data">
              <span
                v-html="data.value"
                @click="fileDownload(data.item.FILE_IDX, data.item.FILE_NAME)"
              ></span>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalCnt"
            :per-page="perPage"
            aria-controls="table1"
          >
          </b-pagination>
        </div>

        <div class="sampleTemplate" v-else>
          <b-table
            id="table2"
            ref="table2"
            :fields="fields"
            :items="getBoard"
            :per-page="perPage"
            :current-page="currentPage"
            @row-clicked="onRowClicked"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            hover
            show-empty
            empty-text="공지사항이 존재하지 않습니다."
          >
            <template #emptyfiltered="scope">
              <h4>{{ scope.emptyFilteredText }}</h4>
            </template>
            <template #cell(FILE_NAME)="data">
              <span v-html="data.value"></span>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalCnt"
            :per-page="perPage"
            aria-controls="table"
          >
          </b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import attatchIcon from "@/assets/images/cmmnMain/첨부파일아이콘.png";
import * as FileUtil from "@/utils/FileUtil";

export default {
  props: ["currentViewLink", "id"],
  computed: {
    ...mapGetters("auth", ["getUser"]),
    isAdmin() {
      if (this.getUser != null && this.getUser.roleName == this.$role.ADMIN) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeCreated() {
    this.setDataTable();
  },
  data() {
    return {
      searchText: this.$route.query.searchText,
      selected: [],
      perPage: 10,
      currentPage: 1,
      totalCnt: 0,
      sortBy: "IDX",
      sortDesc: false,
      fields: [],
      items: [],
      routerName: "",
    };
  },
  methods: {
    onRowClicked(item) {
      let routerName = this.$store.state.board.routerName;
      this.$router.push({
        name: routerName,
        params: { idx: item.IDX, searchText: this.$route.query.searchText },
      });
    },
    showDetail(idx) {
      let routerName = this.$store.state.board.routerName;
      this.$router.push({ name: routerName, params: { idx: idx } });
    },
    fileDownload(fileIdx, fileName) {
      FileUtil.FileDownload("/api/file/fileDownload", fileIdx, fileName);
    },
    isFileUpload(value) {
      if (value) {
        return `<img class='uploadfileImg' src='${attatchIcon}'/>`;
      }
    },
    onRowSelected(items) {
      this.selected = items;
    },
    getBoard(ctx, callback) {
      let searchText = this.$route.query.searchText;
      let boardObj = {
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        searchText: searchText,
      };

      this.$store.dispatch("board/getBoardList", boardObj).then((data) => {
        this.setDataTable();
        callback(data.data.items);
      });

      return null;
    },
    setDataTable() {
      this.currentPage = this.$store.state.board.currentPage;
      this.perPage = this.$store.state.board.perPage;
      this.totalCnt = this.$store.state.board.totalCnt;
      this.sortBy = this.$store.state.board.sortBy;
      this.sortDesc = this.$store.state.board.sortDesc;
      this.fields = this.$store.state.board.fields;
    },
  },
};
</script>

<style scoped lang="scss">
.sampleTemplate ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
.hideItem {
  display: none;
}
</style>
